<template>
  <div class="default">
    <div :class="`default-background ${!isDefaultLayout ? 'second' : ''}`">
      <Navbar />
      <router-view />
      <Footer />
      <BottomNavbar />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import BottomNavbar from '@/components/BottomNavbar';

export default {
  name: 'default',
  components: {
    BottomNavbar,
    Navbar,
    Footer,
  },
  computed: {
    isDefaultLayout() {
      return this.$route?.name === 'home'
    }
  }
};
</script>